export default __webpack_public_path__ + "static/media/gameTrend.bbbba083.jpg";